module.exports = "<div class=\"footer noprint\">\n <app-message></app-message>\n</div>"